import { css, Interpolation, Theme } from '@emotion/react'

export const bulkActionsWrapper: Interpolation<Theme> = css`
  display: flex;
  align-items: center;
  gap: 12px;

  & > button {
    width: 89px;
  }

  & > div {
    width: 162px;
  }
`

export const pageWrapper: Interpolation<Theme> = (theme) => css`
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: ${theme.typographyColors.typographyTwo};

  button {
    width: 48px;
    min-width: 48px;
    padding: 0;

    svg {
      height: 22px;
      width: 22px;
    }
  }

  & > div {
    width: 48px;

    .MuiInputBase-root {
      padding: 0;

      input {
        text-align: center;
      }
    }
  }
`

export const takeWrapper: Interpolation<Theme> = (theme) => css`
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: ${theme.typographyColors.typographyTwo};

  & > div {
    width: 70px;

    .MuiInputBase-root {
      padding: 0;

      input {
        text-align: center;
      }
    }
  }
`

export const filtersWrapper: Interpolation<Theme> = (theme) => css`
  display: flex;
  align-items: center;
  gap: 12px 15px;
  flex-wrap: wrap;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: ${theme.typographyColors.typographyTwo};
`

export const headerWrapper: Interpolation<Theme> = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px 15px;
  flex-wrap: wrap;
  margin-bottom: 24px;
`

export const footerWrapper: Interpolation<Theme> = css`
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 12px 15px;
  flex-wrap: wrap;
  margin-top: 12px;
`
